(() => {
  function syncTheme(dark) {
    document.documentElement.dataset.caTheme = dark ? 'dark' : 'light';
    document.querySelectorAll('[data-ca-theme-toggle]').forEach(button => {
      button.textContent = dark ? button.dataset.lightLabel : button.dataset.darkLabel;
      button.setAttribute('aria-pressed', String(dark));
    });
  }
  document.addEventListener('click', event => {
    if (event.target.closest('[data-ca-theme-toggle]')) {
      const dark = document.documentElement.dataset.caTheme !== 'dark';
      syncTheme(dark);
      try { localStorage.setItem('ca-shop-theme', dark ? 'dark' : 'light'); } catch {}
    }
  });
  document.addEventListener('change', event => {
    if (!event.target.matches('[data-ca-variant]')) return;
    const option = event.target.selectedOptions[0];
    const root = event.target.closest('[data-ca-product]');
    const button = root.querySelector('[data-ca-add]');
    const available = option.dataset.available === 'true';
    root.querySelector('[data-ca-price]').textContent = option.dataset.price;
    button.disabled = !available;
    button.textContent = `[ ${available ? button.dataset.ready : button.dataset.sold} ]`;
  });
  document.addEventListener('shopify:section:load', () => syncTheme(document.documentElement.dataset.caTheme === 'dark'));
  try { syncTheme(localStorage.getItem('ca-shop-theme') === 'dark'); } catch { syncTheme(false); }
})();
